"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var icons_1 = __importDefault(require("../../../../theme/icons"));
var TextInput_1 = __importDefault(require("../../../../common/TextInput/TextInput"));
var general_1 = require("../../../../lib/general");
var MonitoringQuesAnswer = function (props) {
    var _a = (0, react_i18next_1.useTranslation)(), i18n = _a.i18n, t = _a.t;
    var getCurrentLang = i18n.language;
    var error = props.error, editableAnswers = props.editableAnswers;
    var _b = (0, react_1.useState)([
        {
            id: null,
            name: JSON.stringify(props.language || {}),
            published: true,
            sorting: null,
        },
    ]), answers = _b[0], setAnswers = _b[1];
    (0, react_1.useEffect)(function () {
        if (editableAnswers.length > 0) {
            setAnswers(editableAnswers);
        }
    }, [editableAnswers]);
    var addAnswer = function () {
        var _a;
        var newAnswer = {
            id: null,
            name: JSON.stringify((_a = {}, _a[getCurrentLang] = "", _a)),
            sorting: null,
            published: true,
        };
        setAnswers(function (prevAnswers) { return __spreadArray(__spreadArray([], prevAnswers, true), [newAnswer], false); });
    };
    var onHandleChange = function (i, value) {
        var updatedAnswers = answers.map(function (answer, index) {
            var _a;
            return index === i
                ? __assign(__assign({}, answer), { name: JSON.stringify((_a = {}, _a[getCurrentLang] = value, _a)) }) : answer;
        });
        setAnswers(updatedAnswers);
        props.handleMultipleAnswer(updatedAnswers);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                } },
                react_1.default.createElement("label", { className: "label", style: { marginLeft: "0.8rem" } }, (0, general_1.isJsonWithAvailableLang)("answer", getCurrentLang, t)),
                react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "plus", className: "icon", height: 30, width: 30 }), onClick: addAnswer })),
            react_1.default.createElement("p", null, error && error.field === "answer" && error.message),
            answers.map(function (item, idx) {
                var errorMessage = (error === null || error === void 0 ? void 0 : error.field) === "answers" &&
                    error.message.find(function (i) { return i.index === idx; });
                return (react_1.default.createElement("div", { key: idx, style: {
                        display: "flex",
                        boxShadow: "0px 0px 12px 2px #e4f1f5",
                        paddingLeft: "7px",
                        borderColor: "rgb(228, 241, 245)",
                        width: "50%",
                    }, className: "form-container" },
                    react_1.default.createElement(TextInput_1.default, { InputLabelStyle: {
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                        }, error: errorMessage &&
                            errorMessage.type === "name" &&
                            errorMessage.message, label: t("name"), onChange: function (e) { return onHandleChange(idx, e.target.value); }, value: (0, general_1.isJsonWithAvailableLang)(item.name, getCurrentLang.toLowerCase(), t) })));
            }))));
};
exports.default = MonitoringQuesAnswer;
